/**
 * This is the account controller.
 * @memberOf Account Module
 * @namespace Account Controller
 */

/**
 * @name accountController
 * @desc Create the controller.
 * @param $scope
 * @param $translate
 * @param coreService
 * @param accountService
 * @memberOf Account Module.Account Controller
 * @ngInject
 */
function accountController($scope, $translate, coreService, accountService, useEmailLogin, $log, deviceprintFn, whitelabel, $window, deviceprintFnBmo) {



    // Assign this controller as the view-model.
    // It will be accessible as 'accountController' within the HTML template.
    var vm = this;

    // Register the view model's properties.
    vm.validateForm = validateForm;
    vm.submitted = false;
    vm.messages = [];
    vm.user = coreService.user;
    vm.PostLogOutErrorMessage = '';
    vm.PostLogOutErrorCode = ''; 
    vm.formDirty = false;
    vm.isPasswordError = false;
    vm.isUserNameError = false;
    vm.isEmailError = false;
    vm.isPasswordErrorValue = '';
    vm.isUserNameErrorValue = '';
    vm.isEmailErrorValue = '';
    vm.isPageLoadComplete = false;

    // Use email login
    vm.useEmailLogin = useEmailLogin;
    
    vm.displayErrorsOnPassword = displayErrorsOnPassword;
    vm.displayErrorsOnUserName = displayErrorsOnUserName;   
    vm.displayErrorsOnEmail = displayErrorsOnEmail;     
 

    // Activate the controller.
    activate();   

    // Activates the controller.
    function activate() {    

      // Read Identity Server's data model
      var model = coreService.getIdentityModel();
      vm.model = model;

            //Read the secondary user id custom property added by IDAM
      if (model.custom && model.custom.productSuffix) {
        vm.productSuffix = model.custom.productSuffix || ''; 
      }
      
      //If post logout error, show the message in login page.
      var postLogOutErrorCode = localStorage.getItem('logOutErrorCode');      

      if(postLogOutErrorCode)
      {
        vm.PostLogOutErrorMessage = 'account.form.'+ postLogOutErrorCode;
        vm.PostLogOutErrorCode = 'account.form.'+ postLogOutErrorCode;

        if (window.location.pathname.toLowerCase() === '/login')
        {
          deleteLogOutErrorCode();
        }
      }

      //Check if to display error icon or success icon
      vm.PostIsSuccessMessage = false;
      var postIsSuccessMessage = localStorage.getItem('isSuccessMessage');
      if(postIsSuccessMessage !== null && postIsSuccessMessage !== undefined && (postIsSuccessMessage == true || postIsSuccessMessage == 'True')){
        vm.PostIsSuccessMessage = true;        
      }
      localStorage.removeItem('isSuccessMessage');

      // Display error returned by Identity Server
      if (model.errorMessage) {
        vm.messages.push(model.errorMessage);
      }

      // Set default loginUrl if not set in the model
      if (!model.loginUrl) {
        model.loginUrl = '/login?signin=';
      }    
       
      if(deviceprintFn !== null && deviceprintFn !== undefined && typeof deviceprintFn === 'function')
      {
        if(whitelabel !== null && whitelabel !== undefined)
        {
          switch (whitelabel)
          {
            case 'bmo':
              generateDevicePrint(deviceprintFn);
              $scope.device_print_bmo = deviceprintFnBmo();
              break;
            default: 
              generateDevicePrint(deviceprintFn);

            // deviceprintFn.get(function (components) {
            //   //Remove unstable components
            //   components.splice(components.findIndex(i => i.key === 'canvas'), 1);
            //   components.splice(components.findIndex(i => i.key === 'webgl'), 1);
            //   components.splice(components.findIndex(i => i.key === 'hardwareConcurrency'), 1);
            //   components.splice(components.findIndex(i => i.key === 'plugins'), 1);
            //   components.splice(components.findIndex(i => i.key === 'adBlock'), 1);
            //   components.splice(components.findIndex(i => i.key === 'audio'), 1);
            //   components.splice(components.findIndex(i => i.key === 'fonts'), 1);
            //   components.splice(components.findIndex(i => i.key === 'enumerateDevices'), 1);
            //   components.splice(components.findIndex(i => i.key === 'customEntropyFunction'), 1);
            //   var values = components.map(function (component) { return component.value });
            //   $scope.device_print = deviceprintFn.x64hash128(values.join(''), 31);
            // });
          }
        }
      }

      $scope.model = model;  
      
      let stateCheck = setInterval(() => {
        if ($window.document.readyState === 'complete') {
          clearInterval(stateCheck);
          vm.isPageLoadComplete = true;  
          $translate(['account.form.email_invalid', 'account.form.username_required', 
          'account.form.username_minlength', 'account.form.username_maxlength', 
          'account.form.password_required', 'account.form.password_maxlength', 'account.form.email_invalid',
          'account.form.header', 'account.form.username','account.form.email']) 
            .then(function(data) {            
                  vm.data = data;     
                  setAriaLabelOnLoad(true);  
                  if(useEmailLogin)
                  {
                      setFocus("username2");   
                  }
                  else
                  {
                      setFocus("username");  
                  }                   
          });         

          translatePostLogoutMessage();
        }
      }, 0);

      

      $window.document.getElementById("forgottenlink").addEventListener("click", function(){
        deleteLogOutErrorCode();
      });
    }

    $scope.$watch('model.custom.ui_locales', function() { 
      if(typeof($scope.model) != 'undefined' && $scope.model != null && typeof($scope.model.custom) != 'undefined' && $scope.model.custom != null)
      {
        $translate.preferredLanguage($scope.model.custom.ui_locales);
        $translate(['account.form.email_invalid', 'account.form.username_required', 
        'account.form.username_minlength', 'account.form.username_maxlength', 
        'account.form.password_required', 'account.form.password_maxlength', 'account.form.email_invalid',
        'account.form.header', 'account.form.username','account.form.email']) 
        .then(function(data) {
        vm.data = data; 
        });

        translatePostLogoutMessage();
      }
      });

    function translatePostLogoutMessage(){
      
      if(vm.PostLogOutErrorCode.trim() === 'account.form.PostLogoutError_03')
      {
        $translate.preferredLanguage($scope.model.custom.ui_locales);

        //apache-1810
        var textLine0 = "account.form.password_reset_success.text0";
        var textLine1 = "account.form.password_reset_success.text1";
        var textLine2 = "account.form.password_reset_success.text2";
        var textLine3 = "account.form.password_reset_success.text3";

        // Translate the post logout error message
        $translate([textLine0, textLine1, textLine2, textLine3]).then(function (translatedValue) {
                
            // Exit if no translation found
            if (typeof translatedValue === 'undefined' || translatedValue === null || translatedValue.length === 0) return;

            vm.PostLogOutErrorMessage = translatedValue[textLine0] + '<ul>' +
            '<li>' + translatedValue[textLine1] + '</li>' +
            '<li>' + translatedValue[textLine2] + '</li>' +
            '<li>' + translatedValue[textLine3] + '</li>' +
            '</ul>';
        });
      }
      else if (typeof vm.PostLogOutErrorCode !== 'undefined' && vm.PostLogOutErrorCode !== null && vm.PostLogOutErrorCode.trim().length !== 0) {
        $translate.preferredLanguage($scope.model.custom.ui_locales);
        $translate(vm.PostLogOutErrorCode).then(function (translatedValue) {
          vm.PostLogOutErrorMessage = translatedValue;
        });
      }
    }

    function generateDevicePrint(deviceprintFn)
    {
      deviceprintFn.get(function (components) {
        //Remove unstable components
        components.splice(components.findIndex(i => i.key === 'canvas'), 1);
        components.splice(components.findIndex(i => i.key === 'webgl'), 1);
        components.splice(components.findIndex(i => i.key === 'hardwareConcurrency'), 1);
        components.splice(components.findIndex(i => i.key === 'plugins'), 1);
        components.splice(components.findIndex(i => i.key === 'adBlock'), 1);
        components.splice(components.findIndex(i => i.key === 'audio'), 1);
        components.splice(components.findIndex(i => i.key === 'fonts'), 1);
        components.splice(components.findIndex(i => i.key === 'enumerateDevices'), 1);
        components.splice(components.findIndex(i => i.key === 'customEntropyFunction'), 1);
        var values = components.map(function (component) { return component.value });
        $scope.device_print = deviceprintFn.x64hash128(values.join(''), 31);
      });
    }
 
    function deleteLogOutErrorCode()
    {
      $window.localStorage.removeItem('logOutErrorCode');
      $window.localStorage.removeItem('postLogOutErrorCode');
    }

    // Validate the login account form.
    function validateForm(e) {
        // Update the form.
        vm.messages = [];
        vm.PostLogOutErrorMessage = '';
        vm.PostLogOutErrorCode = '';
        vm.submitted = true;
        $scope.accountForm.$dirty = true;
        $scope.accountForm.$pristine = false;
        var isValid = validateEmptyFields();

        if (isValid === false) {
            // Do not submit
            e.preventDefault();
        }

        deleteLogOutErrorCode();
    }
    
    function validateEmptyFields() {
      var valUsername = getUserNameElement().value;
      var valPassword = getPasswordElement().value;

      if(vm.useEmailLogin)
      {
        var valEmail = getUserName2Element().value;
        if (valEmail == "")
        {
          vm.isEmailErrorValue =  '<span class="glyphicon glyphicon-exclamation-sign" aria-hidden="true"></span> <span>'+ vm.data['account.form.email_invalid'] +'</span><br/>';
          vm.formDirty = true;
          vm.isEmailError = true;
          vm.isUserNameError = false;
          vm.isPasswordError = false; 
          displayErrors(vm.isEmailErrorValue);
          setFocus("username2"); 
          return false;
         }
         else if (valUsername == "")
         {
          vm.isUserNameErrorValue =  '<span class="glyphicon glyphicon-exclamation-sign" aria-hidden="true"></span> <span>'+ vm.data['account.form.username_required'] +'</span><br/>';
          vm.formDirty = true;
          vm.isUserNameError = true; 
          vm.isEmailError = false;
          vm.isPasswordError = false; 
          displayErrors(vm.isUserNameErrorValue);
          setFocus("username"); 
          return false;
         }        
         else if (valPassword == "")
         {
          vm.isPasswordErrorValue =  '<span class="glyphicon glyphicon-exclamation-sign" aria-hidden="true"></span> <span>'+ vm.data['account.form.password_required'] +'</span><br/>';
          vm.formDirty = true;
          vm.isPasswordError = true;
          vm.isUserNameError = false;
          vm.isEmailError = false; 
          displayErrors(vm.isPasswordErrorValue); 
          setFocus("password");  
          return false;
         }
      }
      else
      {
        if (valUsername == "")
        {
            vm.isUserNameErrorValue =  '<span class="glyphicon glyphicon-exclamation-sign" aria-hidden="true"></span> <span>'+ vm.data['account.form.username_required'] +'</span><br/>';
            vm.formDirty = true;
            vm.isUserNameError = true; 
            vm.isPasswordError = false;
            displayErrors(vm.isUserNameErrorValue);
            setFocus("username"); 
            return false;
        }        
        else if (valPassword == "")
        {
            vm.isPasswordErrorValue =  '<span class="glyphicon glyphicon-exclamation-sign" aria-hidden="true"></span> <span>'+ vm.data['account.form.password_required'] +'</span><br/>';
            vm.formDirty = true;
            vm.isPasswordError = true;
            vm.isUserNameError = false;
            displayErrors(vm.isPasswordErrorValue);  
            setFocus("password"); 
            return false;
        } 
      }            
      return true;
    }

    function displayErrorsOnUserName(e)
    {
      if(!vm.isPageLoadComplete)
      {
        return;
      }
      var userName = getUserNameElement().value;
      if(isSubmitClick(e,userName))
      {
       return;
      }   
      setAriaLabelOnLoad(false);
      vm.messages = '';
      vm.isUserNameErrorValue = '';
      if(vm.isUserNameError)
      {
        clearErrors();   
      }      
      vm.formDirty = false;
      vm.isUserNameError = false;
       
       if (userName != '' && $scope.accountForm.username.$error.minlength)
       {           
           vm.isUserNameErrorValue =  '<span class="glyphicon glyphicon-exclamation-sign" aria-hidden="true"></span> <span>'+ vm.data['account.form.username_minlength'] +'</span><br/>';
           vm.formDirty = true;  
           vm.isUserNameError = true;  
           vm.isPasswordError = false;
            if(vm.useEmailLogin)
            {
            vm.isEmailError = false; 
            }   
       }
       if (userName != '' && $scope.accountForm.username.$error.maxlength)
       {           
           vm.isUserNameErrorValue =  vm.isUserNameErrorValue + '<span class="glyphicon glyphicon-exclamation-sign" aria-hidden="true"></span> <span>'+ vm.data['account.form.username_maxlength'] +'</span><br/>';
           vm.formDirty = true;   
           vm.isUserNameError = true;
           vm.isPasswordError = false;
           if(vm.useEmailLogin)
           {
            vm.isEmailError = false; 
           } 
       }     

       if(vm.formDirty)
       {
        displayErrors(vm.isUserNameErrorValue);     
        setFocus("username");       
      }     
    }

    function isSubmitClick(e, element)
    {
       // If blur is triggered and the target element is submit button, short circuit this call 
       // to trigger the onclick validation
       if(element.replace(/^\s+|\s+$/g, '') === '' && e !== null && e !== 'undefined' && e.relatedTarget !== null && e.relatedTarget.id !== null && e.relatedTarget.id === 'submitlogin'){
        return true;
       }
       else
       {
         return false;
       }
    }

    function displayErrorsOnPassword(e)
    {
      var password = getPasswordElement().value;

      if(isSubmitClick(e,password))
      {
       return;
      }
     
      vm.messages = '';
      vm.isPasswordErrorValue = '';  
      if(vm.isPasswordError)
      {
        clearErrors();
      }
      vm.isPasswordError = false;
      vm.formDirty = false;      

       if(vm.formDirty)
       {
        displayErrors(vm.isPasswordErrorValue);
        setFocus("password");      
       }
    }

    function displayErrorsOnEmail(e)
    {
      if(!vm.isPageLoadComplete)
      {
        return;
      }
      
      if(vm.useEmailLogin)
      {
        var email = getUserName2Element().value;

       if(isSubmitClick(e,email))
       {
        return;
       }

        vm.messages = '';
        vm.isEmailErrorValue = '';
        if(vm.isEmailError)
        {
          clearErrors();
        }
        vm.isEmailError = false; 
        vm.formDirty = false;        
        if (email != '' && $scope.accountForm.username2.$invalid)
        {           
            vm.isEmailErrorValue =  '<span class="glyphicon glyphicon-exclamation-sign" aria-hidden="true"></span> <span>'+ vm.data['account.form.email_invalid'] +'</span><br/>';
            vm.formDirty = true;
            vm.isEmailError = true;
            vm.isPasswordError = false;
            vm.isUserNameError = false;
        }
         if(vm.formDirty)
         {
          displayErrors(vm.isEmailErrorValue);
          setFocus("username2");      
        }
      }
    }

    function getUserNameElement()
    {
      return $window.document.getElementsByName("username")[0];
    }

    function getUserName2Element()
    {
      return $window.document.getElementsByName("username2")[0];
    }

    function getPasswordElement()
    {
      return $window.document.getElementsByName("password")[0];
    }

    function setFocus(name)
    {
      var element = $window.document.getElementsByName(name);  
      if(typeof( element[0]) != 'undefined' &&  element[0] != null)
      {
        $window.setTimeout(function(){ element[0].focus(); }, 0);
      }     
    }

    function clearErrors()
    {
      var formErrors = $window.document.getElementById('formErrors');
      if(typeof(formErrors) != 'undefined' && formErrors != null)
      {
        formErrors.innerHTML = '';
      }     
    }

    function displayErrors(error)
    {
      var formErrors = $window.document.getElementById('formErrors');
      if(typeof(formErrors) != 'undefined' && formErrors != null)
      {
       formErrors.setAttribute('name', 'formError_' + new Date().getTime());
       formErrors.innerHTML =  '<br/><br/><br/>'+error;    
      }
    }

    function setAriaLabelOnLoad(enable)
    {
      if(vm.useEmailLogin)
      {
        var element = getUserName2Element();
        if(typeof(element) != 'undefined' && element != null)
        {
        if (enable)
        {
          var arialDescriptionText = vm.data['account.form.header'] + ". " + vm.data['account.form.email'];
          element.setAttribute('aria-label', arialDescriptionText);
          var element = getUserNameElement();  
          if(typeof(element) != 'undefined' && element != null)
          {
            element.setAttribute('aria-label', vm.data['account.form.username']);
          }
        }
        else
        {
            element.setAttribute('aria-label', vm.data['account.form.email']);
        }
        }    
      }
      else
      {
        var element = getUserNameElement();  
        if(typeof(element) != 'undefined' && element != null)
        {
        if (enable)
        {
          var arialDescriptionText = vm.data['account.form.header'] + ". " + vm.data['account.form.username'];
          element.setAttribute('aria-label', arialDescriptionText);
        }
        else
        {
            element.setAttribute('aria-label', vm.data['account.form.username']);
        }
        }    
      }                 
    }   
}

export default accountController;



// WEBPACK FOOTER //
// ./src/login/account/account.controller.js